import { CURRI_VERSION } from '../../auth/AuthProvider.tsx'

// "BY THE NUMBERS", as an infinite marquee between hairlines.
//
// Every figure is checkable against the published surface: nine REST
// operations (eight payload routes plus /api/me), seven documented delivery
// statuses, sandbox parity, and the version header partners pin. Nothing
// aspirational rides here — a stat the API can't back up gets added when it
// can be.
const STATS: { value: string; label: string }[] = [
  { value: '[09]', label: 'API OPERATIONS' },
  { value: '[07]', label: 'DELIVERY STATUSES' },
  { value: '[100%]', label: 'SANDBOX PARITY' },
  { value: `[${CURRI_VERSION}]`, label: 'CURRI-VERSION' },
]

// The track holds two copies of the strip; sliding one full copy (-50%) and
// looping reads as seamless. The second copy is presentation only.
const Strip = () => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 48,
      paddingRight: 48,
      flex: 'none',
      fontFamily: 'var(--curri-font-mono)',
      fontSize: 11,
      letterSpacing: '0.06em',
      color: 'var(--curri-text-secondary)',
      whiteSpace: 'nowrap',
    }}
  >
    <span style={{ color: 'var(--curri-text)', fontWeight: 600 }}>
      BY THE NUMBERS
    </span>
    {STATS.map(stat => (
      <span key={stat.label}>
        <span style={{ color: 'var(--curri-accent)', fontWeight: 600 }}>
          {stat.value}
        </span>{' '}
        {stat.label}
      </span>
    ))}
  </div>
)

export const Marquee = () => (
  <div
    style={{
      marginTop: 64,
      borderTop: '1px solid var(--curri-border)',
      borderBottom: '1px solid var(--curri-border)',
      overflow: 'hidden',
      padding: '13px 0',
    }}
  >
    <div
      className="landing-marquee-track"
      style={{ display: 'flex', width: 'max-content' }}
    >
      <Strip />
      <div aria-hidden="true" style={{ display: 'contents' }}>
        <Strip />
      </div>
    </div>
  </div>
)
